export const setAggregateNarrativeState = ({ queryClient, keys, payload }) =>
  queryClient.setQueryData(['aggregateNarrative', ...keys], (prev) => ({
    ...prev,
    data: {
      ...prev?.data,
      narrative: {
        ...prev?.data?.narrative,
        ...payload
      }
    }
  }));
